import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyCWPidhaETvTlWgvLELdT77HZewEne7ZXg",
    authDomain: "chat-app-e1152.firebaseapp.com",
    databaseURL: "https://chat-app-e1152.firebaseio.com",
    projectId: "chat-app-e1152",
    storageBucket: "chat-app-e1152.appspot.com",
    messagingSenderId: "258867966322",
    appId: "1:258867966322:web:8fad5ef6d40e3bdda86deb",
    measurementId: "G-0PF0MZB656"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();



export const googleSignIn = () => {
    firebase.auth().signInWithPopup(provider).catch(function(error) {
        console.log(error)
    });
}